import PropTypes from 'prop-types'
import React from 'react'
import {
  FormGroup,
  FormControl,
  ControlLabel,
  ProgressBar
} from 'react-bootstrap'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import Toggle from 'components/Toggle'
import DefaultBoardTemplate from './DefaultBoardTemplate'
import { injectIntl, FormattedMessage, FormattedDate } from 'react-intl'
const { Static: FormControlStatic } = FormControl

export class Settings extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,

    requestChangeSettings: PropTypes.func.isRequired,

    settings: PropTypes.object.isRequired,
    license: PropTypes.object.isRequired,
    version: PropTypes.string.isRequired
  }

  handleShowVersionClick = () => {
    prompt(this.props.intl.formatMessage({ id: 'LANDING_PAGE_VERSION' }), this.props.version)

    return false
  }

  handleBoardTemplateIdChange = (event) => {
    this.props.requestChangeSettings({
      boardTemplateId: event.target.value === 'null' ? null : Number(event.target.value)
    })
  }

  handleBoardDeleteChange = (value) => {
    this.props.requestChangeSettings({
      allowRemoveBoard: value
    })
  }

  render () {
    const {
      settings,
      license,
    } = this.props

    return (
      <LeftSidebarView
        title={<FormattedMessage id='GENERAL' />}
      >
        <ViewBody>
          <FormGroup>
            <ControlLabel><FormattedMessage id='LANDING_PAGE_SETTINGS' /></ControlLabel>
            <FormControlStatic>
              <a href='#' onClick={this.handleShowVersionClick}><FormattedMessage id='LANDING_PAGE_SHOW_VERSION' /></a><br />
            </FormControlStatic>
          </FormGroup>
          <DefaultBoardTemplate
            boardTemplateId={settings.boardTemplateId}
            onChange={this.handleBoardTemplateIdChange}
          />
          <FormGroup>
            <ControlLabel><FormattedMessage id='LANDING_PAGE_BOARD_DELETION' /></ControlLabel>
            <div>
              <Toggle
                checked={settings.allowRemoveBoard}
                onChange={this.handleBoardDeleteChange}
              />
            </div>
          </FormGroup>
          <FormGroup>
            <ControlLabel><FormattedMessage id='LICENSE_KANBO' /></ControlLabel>
            <p>
              <FormattedDate value={new Date(license.expireMax)}>
                {(date) => (
                  <FormattedMessage id='LICENSE_EXPIRES' values={{ date }} />
                )}
              </FormattedDate>
            </p>
            <p>
              <FormattedMessage
                id='LICENSE_USERS_USED'
                values={{
                  usersCurrent: license.writersCurrent,
                  usersMax: license.writersMax
                }}
              />
              <ProgressBar now={Math.ceil(license.writersCurrent / license.writersMax * 100)} />
            </p>
            {license.readersMax > 0 &&
              <p>
                <FormattedMessage
                  id='LICENSE_READERS_USED'
                  values={{
                    usersCurrent: license.readersCurrent,
                    usersMax: license.readersMax
                  }}
                />
                <ProgressBar now={Math.ceil(license.readersCurrent / license.readersMax * 100)} />
              </p>
            }
          </FormGroup>
        </ViewBody>
      </LeftSidebarView>
    )
  }
}

export default injectIntl(Settings)
